import type { PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { Tabs } from '@factorialco/f0-react/dist/experimental'
import { AvailableModules } from 'generated/featureDefinitions'

import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'

import useLocationsTabs from './tabs'

interface Props {
  locationId: string
}

const CommonHeader = ({ children, locationId }: PropsWithChildren<Props>) => {
  const { pathname } = useLocation()
  const { moduleAvailability } = useModuleAvailability(AvailableModules.space_control)
  const tabs = useLocationsTabs(locationId, moduleAvailability.available)

  const activeTabId = tabs.find((tab) => pathname.startsWith(tab.href))?.id ?? tabs[0]?.id ?? ''

  return (
    <Box width="full">
      <Tabs activeTabId={activeTabId} tabs={tabs} />
      <Box width="full" paddingTop="s24">
        {children}
      </Box>
    </Box>
  )
}

export default CommonHeader
